import { css } from 'styled-components';

// Class toggled on <body> by watchKeyboard() while the on-screen keyboard is up.
export const KEYBOARD_OPEN_CLASS = 'keyboard-open';

// For fixed bottom bars: get out of the way while the user is typing, so the
// focused field isn't covered by the bar sitting on top of the keyboard.
export const hideWhenKeyboardOpen = css`
  body.${KEYBOARD_OPEN_CLASS} & {
    display: none !important;
  }
`;
